import { KeyRound } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { ChangePasswordForm } from '@/components/ChangePasswordForm';
import { Button } from '@/components/ui';
import { ThemeToggle } from '@/lib/theme';
import { LanguageSwitch, t } from '@/lib/i18n';

export function ForcePasswordChangePage() {
  const { user, refresh, logout } = useAuth();
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="absolute end-4 top-4 flex items-center gap-2">
        <LanguageSwitch />
        <ThemeToggle />
      </div>
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-100 text-brand-700">
            <KeyRound className="h-6 w-6" />
          </div>
          <h1 className="mt-4 text-xl font-semibold">{t('Choose a new password')}</h1>
          <p className="mt-1 text-sm text-slate-500">
            {t('{email} — your password was set by an administrator. Please choose your own before continuing.', { email: user?.email ?? '' })}
          </p>
        </div>
        <div className="card p-6">
          <ChangePasswordForm onDone={() => void refresh()} />
        </div>
        <div className="mt-4 text-center">
          <Button variant="ghost" size="sm" onClick={() => void logout()}>
            {t('Sign out')}
          </Button>
        </div>
      </div>
    </div>
  );
}
